import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import {
  BRIEF_CAMPAIGN_DYNAMIC_FACETS_QUERY_KEY,
  BRIEF_DYNAMIC_FACETS_QUERY_KEY,
} from "../contsants";
import { useEffect } from "react";
import { CampaignService } from "../services/Campaign.service";

export function useGetCampaignDynamicFacets(briefId: string) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [...BRIEF_CAMPAIGN_DYNAMIC_FACETS_QUERY_KEY(briefId)],
    queryFn: () => CampaignService.getBriefCampaignDynamicFacets(briefId),
    enabled: !!briefId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    dynamicFacets: data?.data,
    isLoading,
    isError,
  };
}
